import { createFileRoute } from '@tanstack/react-router'
import { MembershipsWithoutMembershipView } from '@/features/memberships/components/memberships-without-membership-view'

export const Route = createFileRoute(
  '/_authenticated/memberships/without-membership'
)({
  component: MembershipsWithoutMembershipView,
})
